import styled from 'styled-components';

import {
    AtSign,
    Bell,
    Brush,
    CircleMinus,
    CreditCard, Delete, Eraser,
    KeyRound,
    Palette,
    User,
    UserRoundX,
    VenetianMask
} from "lucide-react";
import React from "react";
import {FixedTopBar} from '../../components/top_bar';
import {WhiteMain} from "../../components/main";

import NavLink from "../../components/nav_link";
import {themecolors} from "../../utils/themecolors";

const Item = styled.div``;

const Settings = styled(({className}) => {

    return (
        <>
            <FixedTopBar back title="Settings" border={false} black />
            <WhiteMain className={className}>

                <NavLink href={`/settings/general`}>
                    <Item>
                        <User size={20} />
                        General
                    </Item>
                </NavLink>

                <NavLink href={`/settings/profile`}>
                    <Item>
                        <Brush size={20} />
                        Profile
                    </Item>
                </NavLink>

                <NavLink href={`/settings/appearance`}>
                    <Item>
                        <Palette size={20} />
                        Appearance
                    </Item>
                </NavLink>

                <NavLink href={`/settings/notifications`}>
                    <Item>
                        <Bell size={20} />
                        Notifications
                    </Item>
                </NavLink>

                <NavLink href={`/settings/privacy`}>
                    <Item>
                        <VenetianMask size={20} />
                        Privacy
                    </Item>
                </NavLink>

                <NavLink href={`/settings/password`}>
                    <Item>
                        <KeyRound size={20} />
                        Password
                    </Item>
                </NavLink>

                <NavLink href={`/settings/email`}>
                    <Item>
                        <AtSign size={20} />
                        Email Address
                    </Item>
                </NavLink>

                <NavLink href={`/settings/subscription`}>
                    <Item>
                        <CreditCard size={20} />
                        Subscription
                    </Item>
                </NavLink>

                <NavLink href={`/settings/blocked`}>
                    <Item>
                        <UserRoundX size={20} />
                        Blocked Users
                    </Item>
                </NavLink>

                <NavLink href={`/settings/blocked-communities`}>
                    <Item>
                        <CircleMinus size={20} />
                        Blocked Communities
                    </Item>
                </NavLink>

                <NavLink href={`/settings/purge`}>
                    <Item>
                        <Eraser size={20} />
                        Purge Content
                    </Item>
                </NavLink>

                <NavLink href={`/settings/delete`}>
                    <Item>
                        <Delete size={20} />
                        Delete Account
                    </Item>
                </NavLink>

            </WhiteMain>
        </>
    );
})`
  ${Item} {
    color: ${({theme}) => theme.color.name === 'dark' ? theme.white_0 : 'inherit'};
    padding: 12px 24px;
    font-size: 16px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    display: flex;
    align-items: center;
    font-weight: 400;
  }

  ${Item} svg {
    margin-right: 20px;
  }

  ${Item}:active {
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : 'rgba(0,0,0,.06)'};
  }
`;

export default Settings;
